// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/Modal.css
// module id = 1140
// module chunks = 0 1 2